import { useEffect, useState } from "react";
import { getSupportDetail } from "./SupportTicketHelper";
import { get } from "../../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import SupportTicketView from "./SupportTicketView";
import Confirmation from "../../../components/Confirmation";

const SupportTicketActionButton = ({
  id,
  fetchSupportTickets,
  supportDetails,
}) => {
  const [supportDetail, setSupportDetail] = useState();
  const [reply, setReplay] = useState(false);
  const [accessModal, setAccessModal] = useState(false);
  const [accessStatus, setAccessStatus] = useState();
  const [isLoading, setIsLoading] = useState();

  const [showView, setShowView] = useState(false);
  const [showFetch, setShowFetch] = useState(false);
  // const roleType = localStorage.getItem('roleType');

  const fetchData = async () => {
    setLoading(true);
    const userDetailData = await getSupportDetail(id);
    if (userDetailData?.support_ticket_comments?.length === 1) {
      setReplay(true);
    } else {
      setReplay(false);
    }
    setSupportDetail(userDetailData);
    setLoading(false);
  };
  const toggleShowModal = () => {
    if (!showView) {
      fetchData();
    } else {
      fetchSupportTickets();
    }
    setShowView(!showView);
  };

  const toggleAccessModal = (status) => {
    if (accessModal) {
      setAccessStatus("");
    } else {
      setAccessStatus(status);
    }
    setAccessModal(!accessModal);
  };

  const handleAccessStatus = (status) => {
    setIsLoading(true);
    const formData = new FormData();
    if (status === "isResolved") {
      formData.append("is_resolved", 1);
    } else {
      formData.append("status", status);
    }
    formData.append("_method", "put");
    get(
      status === "get-access"
        ? `${status}/${supportDetails?.accounting_firm_id}`
        : `${status}`
    )
      .then((response) => {
        if (response.status === 200) {
          setIsLoading(false);
          toggleAccessModal();
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (showFetch) {
      // fetchSupportTickets();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFetch]);

  return (
    <span style={{ whiteSpace: "nowrap" }}>
      <FontAwesomeIcon
        title="View Support Ticket"
        onClick={toggleShowModal}
        icon={faEye}
        size="1x"
      />

      <SupportTicketView
        showView={showView}
        setShowView={setShowView}
        toggleShowModal={toggleShowModal}
        setShowFetch={setShowFetch}
        loading={loading}
        supportDetail={supportDetail}
        handleDelete={fetchSupportTickets}
        id={id}
        fetchData={fetchData}
        fetchSupportTickets={fetchSupportTickets}
        setReplay={setReplay}
        reply={reply}
      />

      <Confirmation
        title={"Confirmation!"}
        open={accessModal}
        setOpen={setAccessModal}
        toggleShow={() => {
          toggleAccessModal();
        }}
        className="sm:max-w-fit"
        message={
          accessStatus === "get-access"
            ? "Do you want to get the user account access?"
            : accessStatus === "grant-access"
            ? "Do you want to grant the support user to access?"
            : accessStatus === "revoke-access"
            ? "Do you want to revoke the support user to access?"
            : ""
        }
        okAction={async () => {
          await handleAccessStatus(accessStatus);
        }}
        loading={isLoading}
        cancelAction={() => {
          toggleAccessModal();
        }}
      />
    </span>
  );
};

export default SupportTicketActionButton;
